import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    // Clear any remaining user profile data
    localStorage.removeItem('userProfile');
    // Redirect to login page if no token found
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
